module.exports = __webpack_public_path__ + "static/img/on7.c1259756.png";